// extracted by css-extract-rspack-plugin
export default {"cls1":"AuthorPopover-cls1_WKm","cls2":"AuthorPopover-cls2_Kx8 AuthorPopover-cls1_WKm"};